module.exports = __webpack_public_path__ + "media/05.aeb27867.mp3";